/**
 * Runtime flags injected by `server.js` from App Service settings (not Vite build vars).
 * @module utils/portalRuntimeConfig
 */

export type PortalRuntimeConfig = {
  /** When true, anonymous `/` navigates to `/signin` instead of the marketing site. */
  rootSignIn?: boolean;
};

declare global {
  interface Window {
    __PORTAL_RUNTIME__?: PortalRuntimeConfig;
  }
}

/**
 * True when anonymous `/` should stay on the portal (`/signin`) instead of the marketing site.
 * - App Service: `PORTAL_ROOT_SIGNIN=true` → `window.__PORTAL_RUNTIME__.rootSignIn`
 * - Local Vite: localhost / `VITE_PORTAL_ROOT_SIGNIN=true`
 */
export function isPortalRootSignInRedirect(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  if (window.__PORTAL_RUNTIME__?.rootSignIn === true) {
    return true
  }
  if (import.meta.env.VITE_PORTAL_ROOT_SIGNIN === 'true') {
    return true
  }
  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1') {
    return true
  }
  return false
}
